import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import * as DESUI from "react-bootstrap"; import Menubar from "../Menubar"; import { store } from "../../App"; import ShowAlert from "../alert";
import MasterService from "../../Services/MasterService"; import SwaranandhraService from "../../Services/SwaranandhraService"; import { IoIosReturnLeft } from "react-icons/io"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable"; import { Container, Button, Col, Row, Nav } from "reactstrap"; import { generatePdf ,exportToExcel} from "../utils/commonFunctions"; import { Link } from "@mui/material";

const ProgressReport = () => {



  const [mainEnb, setMainEnb] = useState(false);
  const [searchText, setSearch] = useState("");
  const [data, setData] = useState();
  const [distlist, setDistrictList] = useState([]);
  const [distEnb, setDistEnb] = useState(false);
  const [data1, setData1] = useState()
  const [SubEnbmandal, setSubenbmandal] = useState(false)
  const [searchText1, setSearch1] = useState("");
  const [Enblink, setEnbLink] = useState(false)

  const [SubEnbmandal1, setSubEnbmandal1] = useState(false)
  const [SubEnbmandal2, setSubEnbmandal2] = useState(false)
  const [data2, setData2] = useState([]);
  const [searchText2, setSearch2] = useState("");
  const [data3, setData3] = useState([]);
  const [searchText3, setSearch3] = useState("");
  const [Head, setHead] = useState("")

  const [activeTab, setActiveTab] = useState('target');

  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const formik = useFormik({
    initialValues: {
      district_id: ""
    },

  })

  React.useEffect(() => {
    if ((roleid === "2") || (roleid === "10") || (roleid === "3")) { setDistEnb(true) }
    if (roleid === "5") { setDistEnb(false) }
    formik.setFieldValue("district_id", district !== "0" ? district : "");
  }, [])


  useEffect(() => {

    MasterService.getDistricts().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setDistrictList(options);
      }
    });

    if (roleid === "2" || roleid === "10") {
      let params = { "userId": username, "district_id": district }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getProgressreport(params).then((res) => { if (res.data && res.data.SCODE === "01") { setData(res.data.SDESC) }
        setMainEnb(true); setSubenbmandal(false); setSubEnbmandal1(false); setSubEnbmandal2(false);
      }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
    }

  }, []);

  const Back = () => {

    if (roleid === "2" || roleid === "10") {
      let params = {
        "userId": username,
        "district_id": district
      }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getProgressreport(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") { setData(res.data.SDESC) }
        setMainEnb(true); setSubenbmandal(false); setSubEnbmandal1(false);
        setSubEnbmandal2(false)
      }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
    } else if (roleid === "5" || roleid === "8") {
      let params = {
        "userId": username, "district_id": formik.values.district_id
      }
      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getProgressreport(params).then(
        (res) => {
        if (res.data && res.data.SCODE === "01") {setData(res.data.SDESC)

        }
        setMainEnb(true); setSubenbmandal(false);
        setSubEnbmandal1(false); setSubEnbmandal2(false);
      }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })

    }

  }

  const Subdata = (detail, type,) => {
    let params = {
      "userId": username,
      "type": type,
      "district_id": detail.district_id,
    }

    if (params.type === "pendinglistAtAd" || params.type === "pendinglistAtCpo" || params.type === "approvedListAtAdOrCpo") { setEnbLink(true) } 
    else { setEnbLink(false) }
    if (params.type === "pendinglistAtAso") { setHead("Pending Mandals At Aso"); } 
    else if (params.type === "allMandalsAtAdOrCpo") { setHead("All Mandals") }
     else if (params.type === "yetToBeStartedAtAdOrCpo") { setHead("Mandals To be Started") }
    else if (params.type === "pendinglistAtAd") { setHead("Pending Mandals At AD") } 
    else if (params.type === "pendinglistAtCpo") { setHead("Pending Mandals At CPO") }
     else if (params.type === "approvedListAtAdOrCpo") { setHead("Approved Mandals") }


    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.status_list(params).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setData1(res.data.SDESC)
        setMainEnb(false);
        setSubenbmandal(true); setSubEnbmandal1(false);
        setSubEnbmandal2(false);
      }
    }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
  }

  const Subdata1 = (detail) => {
    let params = {
      "userId": username,
      "district_id": detail.district_code.toString(),
      "mandal_id": detail.mandal_code
    }

    SwaranandhraService.dataEntryForTargets(params).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setData2(res.data.SDESC); setMainEnb(false);
        setSubenbmandal(false); setSubEnbmandal1(true); setSubEnbmandal2(true);

      }
    })

    SwaranandhraService.gmdpContributions(params).then((res) => {
      if (res.data && res.data.SCODE === "01") { setData3(res.data.SDESC); setMainEnb(false); setSubenbmandal(false); setSubEnbmandal1(true); }
    })

  }

  const Admindata = (e) => {
    console.log("hiiiiiiiiiii")
    formik.setFieldValue("district_id", e.target.value)
    if ((roleid === "5" || roleid === "8") && (e.target.value !== "" && e.target.value !== undefined)) {
      let params = {
        "district_id": e.target.value === "0" ? null : e.target.value,
        "userId": username,
      }

      store.dispatch({ type: "SHOW_SPINNER" });
      SwaranandhraService.getProgressreport(params).then((res) => 
        {
        if (res.data && res.data.SCODE === "01") {setData(res.data.SDESC)
        }
        setMainEnb(true);
        setSubenbmandal(false);
        setSubEnbmandal1(false); setSubEnbmandal2(false);
      }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
    }
  }



  const filterData = (dataa, search) =>
    search.length > 0
      ? dataa?.filter(item => Object.keys(item).some(key => {
        const value = item[key];
        return value !== null && value.toString().toLowerCase().includes(search.toLowerCase());
      }))
      : dataa;

  const filteredData = filterData(data, searchText); const filteredData1 = filterData(data1, searchText1);
  const filteredData2 = filterData(data2, searchText2); const filteredData3 = filterData(data3, searchText3);

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "80%" }}>
        <div className='sa-title'>
          <h2>Progress <span>Report</span></h2>
        </div>
      </Container>

      <DESUI.Container fluid style={{ width: "80%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

            <div className='mandal-container p-4 mt-2'>

              <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mx-4 mandal-col" >
                  <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span>
                  <Field component="select" name="district_id"
                    disabled={distEnb}
                    className="form-control"
                    onChange={(e) => { Admindata(e) }} >
                    <option value="">--Select--</option>
                    <option value="0">All</option>
                    {distlist}
                  </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
                </Col>

              </Row>
            </div>

          </Form>
        </FormikProvider><br />


        {mainEnb &&
          <>
            <DESUI.Row>
              <DESUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-3" >
                <div class="input-group">
                  <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                  <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch(event.target.value)} />
                </div>
              </DESUI.Col>

              <DESUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                <Button
                  variant="danger"
                  size="sm"
                  className="btn mx-2 pdf-btn"
                  onClick={() => generatePdf("#my-table", "Progress Report")}
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  PDF<MdOutlinePictureAsPdf />
                </Button>


                <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Progress Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </Button>

              </DESUI.Col>
            </DESUI.Row>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
                <DESUI.Table striped bordered hover id="my-table" className="table  custom-table table-responsive" >
                  <thead>

                    <tr>

                      <th  >Sl.No.</th>
                      <th  >District</th>
                      <th >No.Of Mandals</th>
                      <th >To be Started</th>


                      <th >Not Forwarded</th>
                      <th >Pending At AD</th>
                      <th >Pending At CPO</th>
                      <th >Approved</th>

                    </tr>

                  </thead>
                  <tbody>
                    {filteredData?.length === 0 ||
                      filteredData?.length === undefined ? (
                      <tr> <td colSpan={19} className="text-center" style={{ color: "red" }}>Details Not Found</td> </tr>
                    ) : (
                      filteredData?.map((detail, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td className="text-left">{detail.district_name}</td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.mandal_total_count === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "allMandalsAtAdOrCpo"); } }} >{detail.mandal_total_count}</Link></td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.to_bestart_aso_t_a === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "yetToBeStartedAtAdOrCpo"); } }} >{detail.to_bestart_aso_t_a}</Link></td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.pending_at_aso_t_a === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "pendinglistAtAso"); } }}>{detail.pending_at_aso_t_a} </Link></td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.pending_at_ad_t_a === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "pendinglistAtAd"); } }}>{detail.pending_at_ad_t_a} </Link></td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.pending_at_cpo_t_a === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "pendinglistAtCpo"); } }}>{detail.pending_at_cpo_t_a}</Link> </td>
                          <td className="text-end"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { if (detail.approved_t_a === 0) { ShowAlert("No data found", "warning"); } else { Subdata(detail, "approvedListAtAdOrCpo"); } }}>{detail.approved_t_a} </Link></td>


                        </tr>
                      ))
                    )}
                  </tbody>
                  {data.length > 1 ? <tfoot style={{ position: "sticky", bottom: "0px" }} className="text-right">
                    <tr className="table_countshead">
                      <td colSpan={2} className="text-center" style={{ fontWeight: "bold" }}>
                        Totals
                      </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}> {data?.reduce((total, detail) => total + (isNaN(detail.mandal_total_count) ? 0 : detail.mandal_total_count ?? 0), 0)} </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}>{data?.reduce((total, detail) => total + (isNaN(detail.to_bestart_aso_t_a) ? 0 : detail.to_bestart_aso_t_a ?? 0), 0)}
                      </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}>
                        {
                        data?.reduce((total, detail) => total + (isNaN(detail.pending_at_aso_t_a) ? 0 : detail.pending_at_aso_t_a ?? 0), 0)}
                      </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}>
                        {
                        data?.reduce((total, detail) => total + (isNaN(detail.pending_at_ad_t_a) ? 0 : detail.pending_at_ad_t_a ?? 0), 0)}
                      </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}>
                        {
                        data?.reduce((total, detail) => total + (isNaN(detail.pending_at_cpo_t_a) ? 0 : detail.pending_at_cpo_t_a ?? 0), 0)}
                      </td>
                      <td className="text-end" style={{ fontWeight: "bold" }}> {data?.reduce((total, detail) => total + (isNaN(detail.approved_t_a) ? 0 : detail.approved_t_a ?? 0), 0)}
                      </td>
                    </tr>
                  </tfoot> : null}
                </DESUI.Table>
              </div>
            </div>
          </>
        }


        {SubEnbmandal && <>
          <DESUI.Row  >
            <DESUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-2" style={{ marginLeft: "40px" }}>
              <div class="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch1(event.target.value)} />
              </div>
            </DESUI.Col>

            <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-center" >
              <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={() => generatePdf("#my-table1", "Progress Report")} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /> </Button>



              <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "Progress Report")} >
                Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
              </Button>
            </DESUI.Col>
            <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-end" >
              <Button variant="warning" className="btn btn-sm warn-btn" onClick={Back} style={{ float: "right", marginLeft: "3px" }} ><IoIosReturnLeft /> BACK</Button>
            </DESUI.Col>
          </DESUI.Row>
          <div id="table-scroll" className="table-scroll" style={{ width: "72%" }}>
            <div className="table-wrap">
              <DESUI.Table bordered hover id="my-table1" className="table custom-table table-responsive">
                <thead>
                  <tr><th colSpan={3}  >{Head}</th></tr>
                  <tr className="text-center">
                    <th >Sl.No.</th>

                    <th >Mandal Name</th>

                  </tr>
                </thead>
                <tbody>
                  {filteredData1?.length === 0 ||
                    filteredData1?.length === undefined ? (
                    <tr> <td colSpan={2} className="text-center" style={{ color: "red" }}>Details Not Found</td> </tr>
                  ) : (
                    filteredData1?.map((detail, i) => (
                      <tr key={i}>
                        <td style={{ textAlign: "center" }}>{i + 1}</td>
                        {Enblink ?
                          <td className="text-left"><Link style={{ cursor: "pointer", color: "blue", textDecoration: "none", fontFamily: "sans-serif" }} onClick={() => { Subdata1(detail); }}>{detail.mandal_name}</Link></td> :
                          <td className="text-left">{detail.mandal_name}</td>}
                      </tr>
                    ))
                  )}
                </tbody>
              </DESUI.Table>
            </div>

          </div>
        </>

        }

        {SubEnbmandal1 || SubEnbmandal2 ?
          <>
            <Nav variant="pills" className="flex-column">
              <Row className="tabs-row">
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-0">
                  <button
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      backgroundColor: 'transparent',
                      border: 'none',
                      borderBottom: activeTab === 'target' ? '3px solid #8967B3' : '2px solid transparent',
                      fontWeight: activeTab === 'target' ? 'bold' : 'normal',
                      marginRight: '10px',
                    }}
                    onClick={() => setActiveTab("target")}
                    className="tab-boxes tab-boxes1"
                  >
                    TARGETS & ACHIEVEMENT ENTRY
                  </button>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12} className="px-1">
                  <button
                    style={{
                      padding: '10px',

                      border: 'none',
                      borderBottom: activeTab === 'gdmp' ? '3px solid #8967B3' : '2px solid transparent',
                      fontWeight: activeTab === 'gdmp' ? 'bold' : 'normal',
                    }}
                    onClick={() => {
                      setActiveTab("gdmp")
                    }}
                    className="tab-boxes tab-boxes2"

                  >  GROSS MANDAL DOMESTIC PRODUCT ENTRY
                  </button>
                </Col>
              </Row>
            </Nav>
          </>
          : null}



        {SubEnbmandal1 && activeTab === "target" &&
          <>
            <DESUI.Row className="mt-2">
              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mb-3" >
                <div class="input-group">
                  <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                  <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch2(event.target.value)} />
                </div>
              </DESUI.Col>

              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2" >
                <Button variant="danger" size="sm" className="btn mx-4 pdf-btn" onClick={() => generatePdf("#my-table2", "Progress Report")} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /></Button>

                <Button
                variant="success"
                size="sm"
                className="btn mx-2 excel-btn"
                style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                onClick={() => exportToExcel("my-table2", "Progress Report")}
              >
                Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
              </Button>  
                          </DESUI.Col>
              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2" >
                <Button variant="warning" className="btn  btn-sm warn-btn" onClick={Back} style={{ float: "right", marginLeft: "3px" }} ><IoIosReturnLeft /> BACK</Button>
              </DESUI.Col>
            </DESUI.Row>

            <DESUI.Table bordered hover id="my-table2" className="table custom-table table-responsive" >
              <thead>
                <tr><th colSpan={11}>Targets & Achievements Details</th></tr>

                <tr className="text-center">
                  <th rowSpan={2}>Sl.No.</th>
                  <th rowSpan={2}>SECTOR</th>
                  <th rowSpan={2}>INDICATOR</th>
                  <th rowSpan={2}>UNIT</th>
                  <th colSpan={1}>ACHIEVEMENTS</th>
                  <th colSpan={5}>TARGETS</th>
                  <th rowSpan={2}>Indicative Financial <br />Plan-Expected sources <br /> of funding</th>
                </tr>
                <tr>
                  <th>2023-24</th>
                  <th>2024-25</th>
                  <th>2025-26</th>
                  <th>2026-27</th>
                  <th>2027-28</th>
                  <th>2028-29</th>
                </tr>
              </thead>
              <tbody>
                {filteredData2?.length === 0 ||
                  filteredData2?.length === undefined ? (
                  <tr> <td colSpan={11} className="text-center" style={{ color: "red" }}>Details Not Found</td> </tr>
                ) : (
                  (() => {
                    let previousIndicator = null;
                    return filteredData2?.map((detail, i) => {
                      const showIndicatorName = detail.indicator_name !== previousIndicator;
                      previousIndicator = detail.indicator_name;

                      return (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td className="text-left" style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>
                            {showIndicatorName ? detail.indicator_name : null}
                          </td>
                          <td className="text-left" style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }} >{detail.sub_indicator_name}</td>
                          <td className="text-right" style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }} >{detail.unit}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.achived}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.target_2024_2025}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.target_2025_2026}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }} >{detail.target_2026_2027}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.target_2027_2028}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.target_2028_2029}</td>
                          <td className="text-end " style={{ backgroundColor: showIndicatorName ? "#FCDC94" : "inherit" }}>{detail.source_of_funding}</td>
                        </tr>
                      );
                    });
                  })()
                )}
              </tbody>
            </DESUI.Table>
          </>}

        {SubEnbmandal2 && activeTab === "gdmp" &&
          <>
            <DESUI.Row>
              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mb-3"  >
                <div class="input-group">
                  <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                  <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch3(event.target.value)} />
                </div>
              </DESUI.Col>

              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 " >
                <Button variant="danger" size="sm" className="btn mx-4 pdf-btn" onClick={() => generatePdf("#my-table3", "Progress Report")} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /> </Button>
               
              <Button
                variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table3", "Progress Report")}
              >
                Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
              </Button>
              </DESUI.Col>

              <DESUI.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-center" >
                <Button className="btn save-btn btn-sm warn-btn" onClick={Back} style={{ float: "right", marginLeft: "3px" }} variant="warning" ><IoIosReturnLeft /> BACK</Button>
              </DESUI.Col>
            </DESUI.Row>

            <DESUI.Table bordered hover id="my-table3" className="table  custom-table table-responsive">
              <thead>
                <tr><th colSpan={5}>Gross Mandal Domestic Product Details</th></tr>
                <tr className="text-center">
                  <th rowSpan={2}>Sl.No.</th>
                  <th rowSpan={2}>BROAD SECTOR</th>
                  <th rowSpan={2}>SUB SECTOR</th>
                  <th colSpan={2}>2022-23</th>
                </tr>
                <tr>
                  <th>GVA<br />(Rs. In Lakhs)</th>
                  <th>Contribution (%)</th>
                </tr>
              </thead>
              <tbody>
                {filteredData3?.length === 0 ||
                  filteredData3?.length === undefined ? (
                  <tr> <td colSpan={5} className="text-center" style={{ color: "red" }}>Details Not Found</td> </tr>
                ) : (
                  (() => {
                    let previousSector = null;
                    return filteredData3?.map((detail, i) => {

                      const isValidSector = detail.sector_name && detail.sector_name.trim() !== "";
                      const showSectorName = isValidSector && detail.sector_name !== previousSector;

                      if (isValidSector) {
                        previousSector = detail.sector_name;
                      }

                      return (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td className="text-left" >
                            {showSectorName ? detail.sector_name : null}
                          </td>
                          <td style={{ textAlign: "left" }}>{detail.industry_name}</td>
                          <td className="text-end">{detail.gmdp}</td>
                          {detail.is_data_entry ? <td className="text-end">{detail.contribution}</td> :
                            (detail.industry_id === 22 && detail.gmdp !== 0) && <td style={{ textAlign: "right" }}>100</td>

                          }
                        </tr>
                      );
                    });
                  })()
                )}
              </tbody>
            </DESUI.Table>
          </>}
      </DESUI.Container >
    </>
  );
};
export default ProgressReport;


